import { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import { StatusChip } from './StatusChip';

export const SystemHeader = ({
  index,
  title,
  subtitle,
  tag,
  status,
  rightNode,
  className
}: {
  index: string;
  title: string;
  subtitle?: string;
  tag?: string;
  status?: string;
  rightNode?: ReactNode;
  className?: string;
}) => {
  return (
    <header className={cn('flex flex-wrap items-start justify-between gap-4', className)}>
      <div>
        <p className="hud-micro text-brand-lime">{index}</p>
        <h2 className="mt-2 font-display text-2xl font-semibold leading-tight text-brand-text sm:text-[2rem]">{title}</h2>
        {subtitle ? <p className="mt-3 max-w-3xl text-sm text-brand-text-2 sm:text-base">{subtitle}</p> : null}
      </div>
      <div className="flex flex-wrap items-center justify-end gap-2">
        {tag ? <span className="hud-chip">{tag}</span> : null}
        {status ? <StatusChip label={status} /> : null}
        {rightNode}
      </div>
    </header>
  );
};
